export const USER_INIT = 'userInit'
export const USER_REGISTER = 'userRegister'
export const USER_UPDATE = 'userUpdate'
export const USER_LOGIN = 'userLogin'
export const USER_LOGOUT = 'userLogout'
export const USER_REQUEST_PASSWORD = 'userRequestPassword'